import { useState } from 'react';
import styled, { css } from 'styled-components';
import Text from 'components/atoms/Text';
import Button from 'components/atoms/Button';
import Colors from 'components/tokens/Colors';
import { Row, Col } from 'components/atoms/Grid';
import { emailValidator } from 'helpers/formValidators';

export default function NewsletterForm({ onValidated, isMobile, status }) {
    const [email, setEmail] = useState(null);
    const [error, setError] = useState(null);
    const [hidePlaceholder, setHidePlaceholder] = useState(false);

    const handleFormSubmit = () => {
        if (!email) {
            setError('Por favor, digite um e-mail.');

            if (isMobile) {
                setHidePlaceholder(true);
            }

            return false;
        }

        if (email && !emailValidator(email)) {
            setError('Insira um e-mail válido.');

            if (isMobile) {
                setHidePlaceholder(true);
            }

            return false;
        }

        const isFormValidated = onValidated({ EMAIL: email });

        return email && isFormValidated;
    };

    const handleInputKeyEvent = event => {
        setError(null);

        if (event.keyCode === 13) {
            event.preventDefault();
            handleFormSubmit();
        }
    };

    return (
        <NewsletterStyled>
            {status === 'success' ? (
                <Text body2 color={Colors.grey}>
                    <b>Tudo certo!</b> A newsletter vai chegar semanalmente no seu e-mail.
                </Text>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Row>
                        <Col size="12 auto" mb="3 0" px="1.5 1" style={{ flexGrow: 1 }}>
                            <StyledInput
                                type="email"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                placeholder={hidePlaceholder ? '' : 'exemplo@mail.com'}
                                error={error}
                                onKeyUp={e => handleInputKeyEvent(e)}
                            />
                            <Message>{error}</Message>
                        </Col>
                        <Col size="12 auto" pl="1.5 1" pr="1.5 0">
                            <Button onClick={handleFormSubmit} dark>
                                Inscrever-se
                            </Button>
                        </Col>
                    </Row>
                </div>
            )}
        </NewsletterStyled>
    );
}

const NewsletterStyled = styled.div`
    width: 100%;
`;

const StyledInput = styled.input`
    background: ${Colors.lightGrey};
    outline: none;
    border: 0;
    padding: 0 16px;
    display: inline-flex;
    align-items: center;
    border-radius: 8px;
    height: 54px;
    font-size: 1.6rem;
    width: 100%;

    ${props =>
        props.error &&
        css`
            border: 2px solid ${Colors.red};
        `}
`;

const Message = styled.span`
    position: absolute;
    right: 80px;
    top: 17px;
    color: ${Colors.red};

    @media (max-width: 768px) {
        right: 55px;
        background: ${Colors.lightGrey};
    }
`;
